var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2923 58.0283V35.9464H71.3221V79.725H78.3814C80.3382 74.1014 85.7327 70.0482 92.0691 70.0482C98.4055 70.0482 103.8 74.1014 105.757 79.725H112.813V58.0283H82.2923Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.658 35.9464H88.5508V51.832H102.168L96.658 35.9464Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4612 92.1407C98.8043 90.8377 101.258 86.2957 99.942 81.9959C98.626 77.696 94.0383 75.2666 89.6953 76.5696C85.3523 77.8726 82.8984 82.4146 84.2145 86.7144C85.5306 91.0143 90.1182 93.4437 94.4612 92.1407Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 63.84V79.7255H13.0568C15.0136 74.1019 20.4081 70.0487 26.7443 70.0487C33.0805 70.0487 38.4752 74.1017 40.4318 79.7255H65.0633V63.84H6Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 35.9464H65.0633V43.6966H6V35.9464Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H65.0633V29.7502H6V22Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 49.8931H65.0633V57.6433H6V49.8931Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7447 92.5154C31.2829 92.5154 34.9618 88.8731 34.9618 84.3801C34.9618 79.887 31.2829 76.2447 26.7447 76.2447C22.2065 76.2447 18.5276 79.887 18.5276 84.3801C18.5276 88.8731 22.2065 92.5154 26.7447 92.5154Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.cf06c204897df6b8aa1f9dce116c8f12.svg";
export { ForwardRef as ReactComponent };